"use client"

import { ReactNode, useEffect, useState } from "react"
import { usePathname } from "next/navigation"
import Header from "@/components/header"
import Footer from "@/components/footer"

export default function RootChrome({ children, initialMaintenance = false }: { children: ReactNode, initialMaintenance?: boolean }) {
  // Always declare hooks in the same order on every render
  const pathname = usePathname()
  const [isMaintenanceCookie, setIsMaintenanceCookie] = useState(initialMaintenance)

  useEffect(() => {
    try {
      const has = document.cookie.split(';').some(c => c.trim().startsWith('site_maintenance=1'))
      setIsMaintenanceCookie(has)
    } catch {}
  }, [])

  // Derive maintenance state after hooks
  const maintenanceRoute = pathname === "/maintenance" || pathname?.startsWith("/maintenance/")
  const isMaintenance = initialMaintenance || isMaintenanceCookie || maintenanceRoute

  return isMaintenance ? (
    <main className="flex-1">{children}</main>
  ) : (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}